import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AppService } from '../../../../../app.service';
import { Router } from '@angular/router';
import { AlertService } from '../../../../shared/alert/alert.service';

@Component({
  selector: 'app-login-otp',
  templateUrl: './login-otp.component.html',
  styleUrl: './login-otp.component.scss'
})
export class LoginOtpComponent {
  email: any
  otpForm: FormGroup;
  otpControls = ['digit1', 'digit2', 'digit3', 'digit4', 'digit5', 'digit6'];

  constructor(private fb: FormBuilder, public commonService: AppService, public router: Router, public alertService: AlertService) { }

  ngOnInit() {
    this.otpForm = this.fb.group(
      this.otpControls.reduce((acc, key) => ({ ...acc, [key]: [''] }), {})
    );
    this.email = this.commonService.getEmail();
  }

  onInput(event: any, index: number) {
    const input = event.target;
    const nextInput = input.nextElementSibling;
    if (input.value && nextInput) {
      nextInput.focus();
    }
  }

  onKeydown(event: any, index: number) {
    const input = event.target;
    const prevInput = input.previousElementSibling;

    if (event.key === 'Backspace' && !input.value && prevInput) {
      prevInput.focus();
    }
  }

  onSubmit() {
    const otpValue = this.otpControls.map(ctrl => this.otpForm.get(ctrl)?.value).join('');
    let url = 'api/Auth/validateOTP'
    let payload =
    {
      email: this.email,
      otp: otpValue
    }
    this.commonService.post(url, payload).subscribe({
      next: (res: any) => {
        this.alertService.success(res.message);
        this.router.navigate(['reset-password'])
      },
      error: (err: any) => {
        this.alertService.error(err.error.message);
      }
    })
  }

  otpVisible: boolean = false; 
  toggleOtpVisibility() {
    this.otpVisible = !this.otpVisible;
  }
}
